import { render } from "./SalesQuoteDetailModal.vue?vue&type=template&id=d0126086&ts=true"
import script from "./SalesQuoteDetailModal.vue?vue&type=script&lang=ts"
export * from "./SalesQuoteDetailModal.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\DDrive\\DeveloperFolder\\VueJsApps\\byihusemanagt\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__